// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusFilter_wrapper__jPZuE","dark":"StatusFilter_dark__Enuxy"};